
const domainUrl = window.location.origin;

export default {
    name:         "MaxxPainn",
    domain:       window.location.host,
    description:  "MaxxPainn: a free-to-mint Solana protocol championing free, fair and equal token distribution.",
    url:          domainUrl,
    logo:         `${domainUrl}/logo.png`,
    tokenBuyUrl:  "#",
    imageCdn:     "https://api.maxxpainn.com"
}
